"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineTabs = exports.Tabs = void 0;
const Tabs_1 = __importDefault(require("./Component/Tabs"));
var Tabs_2 = require("./Component/Tabs");
Object.defineProperty(exports, "Tabs", { enumerable: true, get: function () { return __importDefault(Tabs_2).default; } });
function defineTabs() {
    if (!customElements.get("wr-tabs")) {
        customElements.define("wr-tabs", Tabs_1.default);
    }
}
exports.defineTabs = defineTabs;
//# sourceMappingURL=index.js.map